























import { Component, Prop, Vue } from 'vue-property-decorator';
// eslint-disable-next-line no-unused-vars
import { IAdditionalSigner } from '@/utils/types';

@Component({
  components: {},
  data: () => ({}),
})
export default class StatusAdditionalSigners extends Vue {
  @Prop({ default: () => [] }) data!: IAdditionalSigner[];

  get additionalSigners() {
    return this.data.map((item: IAdditionalSigner) => {
      return {
        ...item,
        fullName: `${item.lastName} ${item.name[0]}. ${
          item.middleName ? item.middleName[0] + '.' : ''
        }`,
        signedDesc: item.signed ? 'Подписан' : 'Не подписан',
      };
    });
  }
}
